// extracted by mini-css-extract-plugin
export default {"container":"footer_container__ccguW","logo_container":"footer_logo_container__cEDum"};